import { Col, Collapse, Modal, Popover, Row } from "antd";
import { AppTransactionResponseModel } from "api/repositories/appTransaction/models/AppTransactionResponseModel";
import { ProductDetail } from "components/generalComponents/productDetailForTransaction/ProductDetail";
import ServiceEditorComponent from "components/generalComponents/serviceEditorComponent/ServiceEditorComponent";
import dayjs from "dayjs";
import { isEmpty } from "lodash";
import { FaInfoCircle } from "react-icons/fa";
import {
  formatCurrency,
  parseNoteString,
  renderItem,
} from "utils/helpersInTs/helpersInTs";
import { strings } from "utils/localizedStrings";

const AppTransactionDetailModal = ({
  open,
  onCancel,
  detail,
  loading,
  Constants,
}: {
  open: boolean;
  onCancel: () => void;
  detail: AppTransactionResponseModel;
  loading: boolean;
  Constants: any;
}) => {
  const AmountDetail = ({
    children,
    list,
  }: {
    children?: React.ReactNode;
    list?: Array<{
      value?: number;
      name?: string;
    }>;
  }) => {
    return (
      <Popover
        placement="bottomRight"
        arrow={false}
        trigger={["click"]}
        content={
          <>
            {list?.map((item) =>
              renderItem(
                strings.AppTransactionHistory.Labels.AmountLabel?.[
                  item?.name as keyof typeof strings.AppTransactionHistory.Labels.AmountLabel
                ],
                item?.name === "discountRate"
                  ? `${item?.value}%`
                  : formatCurrency(item?.value, true)
              )
            )}
          </>
        }
      >
        {children!}
      </Popover>
    );
  };

  return (
    <Modal
      loading={loading}
      open={open}
      onCancel={() => {
        onCancel();
      }}
      centered
      styles={{
        body: {
          overflowY: "auto",
          maxHeight: "calc(100vh - 120px)",
          scrollbarWidth: "none",
          overflowX: "hidden",
        },
      }}
      footer={null}
      title={
        <span className="font-bold">
          {strings.AppTransactionHistory.Labels.DetailTrans}
        </span>
      }
      width={1000}
    >
      <Row gutter={[8, 32]} justify={"space-between"} className="mt-4 mb-10">
        <Col xs={24} lg={11}>
          {renderItem(
            strings.AppTransactionHistory.Labels.Time,
            dayjs(detail?.createdAt).format("DD/MM/YYYY HH:mm:ss")
          )}
          {renderItem(strings.AppTransactionHistory.Labels.Code, detail?.code)}
          {renderItem(
            strings.AppTransactionHistory.Labels.Platform,
            detail?.platform || parseNoteString(detail?.note)?.["platform"]
          )}
          {renderItem(
            strings.AppTransactionHistory.Labels.Status,
            Constants.statusOption?.find(
              (status: any) =>
                status.value === detail?.status && status.value !== ""
            )?.label,
            Constants.statusOption?.find(
              (status: any) =>
                status.value === detail?.status && status.value !== ""
            )?.color
          )}
          {renderItem(
            strings.AppTransactionHistory.Labels.Total,
            <div className="flex flex-row items-center">
              {formatCurrency(
                detail?.transactionDetail?.info?.totalAmount || 0,
                true
              )}
              {!isEmpty(detail?.transactionDetail?.info?.amount) && (
                <AmountDetail list={detail?.transactionDetail?.info?.amount}>
                  <FaInfoCircle className="ml-2 hover:cursor-pointer" />
                </AmountDetail>
              )}
            </div>
          )}
        </Col>
        <Col xs={24} lg={11}>
          {renderItem(
            strings.AppTransactionHistory.Labels.Type,
            Constants.typeOption?.find(
              (type: any) => type.value === detail?.type && type.value !== ""
            )?.label
          )}
          {renderItem(
            strings.AppTransactionHistory.Labels.Service,
            detail?.service.name
          )}
          {!!detail?.product &&
            renderItem(
              strings.AppTransactionHistory.Labels.Product,
              <ProductDetail
                product={detail?.product}
                Constants={Constants}
                service={detail?.service?.code}
              />
            )}
          {renderItem(
            strings.AppTransactionHistory.Labels.PaymentMethod,
            detail?.paymentMethod?.displayName
          )}
          {renderItem(
            strings.AppTransactionHistory.Labels.Description,
            detail?.description
          )}
        </Col>
        <Col xs={24} lg={11}>
          {renderItem(
            strings.AppTransactionHistory.Labels.UserName,
            detail?.user?.fullName
          )}
          {renderItem(
            strings.AppTransactionHistory.Labels.UserCode,
            detail?.user?.code
          )}
          {renderItem(
            strings.AppTransactionHistory.Labels.BuyerPhone,
            detail?.user?.phone
          )}
          {renderItem(
            strings.AppTransactionHistory.Labels.BuyerEmail,
            detail?.user?.email
          )}
          {renderItem(
            strings.AppTransactionHistory.Labels.BuyerAddress,
            detail?.user?.address
          )}
        </Col>
        <Col xs={24} lg={11}>
          {renderItem(
            strings.AppTransactionHistory.Labels.BuyerName,
            detail?.transactionDetail?.buyer?.name
          )}
          {renderItem(
            strings.AppTransactionHistory.Labels.BuyerPhone,
            detail?.transactionDetail?.buyer?.phone
          )}
          {renderItem(
            strings.AppTransactionHistory.Labels.BuyerEmail,
            detail?.transactionDetail?.buyer?.email
          )}
          {renderItem(
            strings.AppTransactionHistory.Labels.BuyerAddress,
            detail?.transactionDetail?.buyer?.address
          )}
        </Col>
      </Row>
      <Collapse
        items={[
          {
            key: "log",
            label: <span className="font-bold">Log</span>,
            children: (
              <ServiceEditorComponent readOnly content={{ json: detail }} />
            ),
          },
        ]}
        className="font-bold w-full overflow-auto bg-white"
        expandIconPosition="end"
      />
    </Modal>
  );
};

export default AppTransactionDetailModal;
